// GENERATED DO NOT EDIT
import {MuWidget} from 'mu-widget/lib/MuWidget';
import * as uiScripting from '../UiScripting';
import * as htmlarea from '../Htmlarea';
import * as uiFlashMessage from '../UiFlashMessage';
import * as uiSelector from '../UiSelector';
import * as ticketTree from '../TicketTree';
import * as invoiceApproval from '../InvoiceApproval';
import * as uiFlashMessage from '../UiFlashMessage';
import * as accountSelector from '../AccountSelector';
import * as searchSelector from '../SearchSelector';
import * as approvingSchemaEditor from '../ApprovingSchemaEditor';
import * as ticketTree from '../TicketTree';
import * as accountRoles from '../AccountRoles';
import * as shareButton from '../ShareButton';
import * as tPFAttaches from '../TPFAttaches';
import * as treeSelector from '../TreeSelector';
import * as multiUpload from '../MultiUpload';
import * as ticketFormField from '../TicketFormField';
import * as worklogSimple from '../WorklogSimple';
import * as showMore from '../ShowMore';
import * as accountRolesField from '../AccountRolesField';
import * as bulkStateChange from '../BulkStateChange';
import * as accountRolesField from '../AccountRolesField';
import * as uiBilling from '../UiBilling';
import * as uiSavedFilters from '../UiSavedFilters';
import * as uiSavedFiltersAdmin from '../UiSavedFiltersAdmin';
import * as uiNotify from '../UiNotify';
import * as urlInput from '../UrlInput';
import * as showMore from '../ShowMore';
import * as course from '../Course';
import * as courseEditor from '../CourseEditor';
import * as searchSelector from '../SearchSelector';
import * as uiSelect from '../UiSelect';
import * as cronRuleItems from '../CronRuleItems';
import * as calendarPage from '../CalendarPage';
import * as uiCalendarItemDetail from '../UiCalendarItemDetail';
import * as topPage from '../TopPage';
import * as todoTicketForm from '../TodoTicketForm';
import * as attachList from '../AttachList';
import * as components_UiTable from '../components/UiTable';
import * as components_UiTomSelect from '../components/UiTomSelect';
import * as components_UiBuSubjectSelector from '../components/UiBuSubjectSelector';
import * as components_UiOrgProjectSelector from '../components/UiOrgProjectSelector';
import * as components_UiAccountSelector from '../components/UiAccountSelector';
import * as components_UiDateFilter from '../components/UiDateFilter';
import * as components_UiRadioList from '../components/UiRadioList';
import * as components_UiPager from '../components/UiPager';
import * as components_UiTree from '../components/UiTree';
import * as components_UiInlineTreeSelector from '../components/UiInlineTreeSelector';
import * as components_UiDateTimeRange from '../components/UiDateTimeRange';
import * as components_UiNumberRange from '../components/UiNumberRange';
import * as components_Pager from '../components/Pager';
import * as components_AccountLink from '../components/AccountLink';
import * as components_TreeView from '../components/TreeView';
import * as components_UiChboxList from '../components/UiChboxList';
import * as components_BaseCompanyForm from '../components/BaseCompanyForm';
import * as components_RelatedAccountSelector from '../components/RelatedAccountSelector';
import * as uiCharCounter from '../UiCharCounter';
import * as components_DateRepeating from '../components/DateRepeating';
import * as components_CalendarOverview from '../components/CalendarOverview';
import * as dms_UiDms from '../dms/UiDms';
import * as dms_UiBuSubjectEditor from '../dms/UiBuSubjectEditor';
import * as dms_UiDmsDocumentEditor from '../dms/UiDmsDocumentEditor';
import * as dms_UiBuSubjects from '../dms/UiBuSubjects';
import * as dms_UiDmsDocuments from '../dms/UiDmsDocuments';
import * as dms_UiDocumentListPreview from '../dms/UiDocumentListPreview';
import * as dms_UiDmsAttaches from '../dms/UiDmsAttaches';
import * as dms_UiDmsHistory from '../dms/UiDmsHistory';
import * as dms_UiDmsOrgProjects from '../dms/UiDmsOrgProjects';
import * as dms_UiNewDocumentAttach from '../dms/UiNewDocumentAttach';
import * as pqm_ProcDataField from '../pqm/ProcDataField';
import * as uiProjectImport from '../UiProjectImport';
import * as todo_UiTodoButton from '../todo/UiTodoButton';
import * as uiComments from '../UiComments';
import * as uiModalContainer from '../UiModalContainer';
import * as ticketOverview_BaseTO from '../ticketOverview/BaseTO';
import * as ticketOverview_TOInvoiceApproving from '../ticketOverview/TOInvoiceApproving';
import * as ticketOverview_TOIInvoiceApproving from '../ticketOverview/TOIInvoiceApproving';
import * as ticketOverview_InvoiceApprovingFilter from '../ticketOverview/InvoiceApprovingFilter';
import * as ticketOverview_TOPqm from '../ticketOverview/TOPqm';
import * as ticketOverview_pqm_UiPqmLauncher from '../ticketOverview/pqm/UiPqmLauncher';
import * as pqm_PqmTicketList from '../pqm/PqmTicketList';
import * as pqm_PqmTicketDetail from '../pqm/PqmTicketDetail';
import * as pqm_PqmField from '../pqm/PqmField';
import * as pqm_PqmPackets from '../pqm/PqmPackets';
import * as pqm_Fields_PqmFieldText from '../pqm/Fields/PqmFieldText';
import * as pqm_Fields_PqmFieldDate from '../pqm/Fields/PqmFieldDate';
import * as pqm_Fields_PqmFieldBool from '../pqm/Fields/PqmFieldBool';
import * as pqm_Fields_PqmFieldEnum from '../pqm/Fields/PqmFieldEnum';
import * as pqm_Fields_PqmFieldSet from '../pqm/Fields/PqmFieldSet';
import * as pqm_Fields_PqmFieldCompany from '../pqm/Fields/PqmFieldCompany';
import * as pqm_Fields_PqmFieldAccount from '../pqm/Fields/PqmFieldAccount';
import * as pqm_Fields_PqmFieldOrgDivision from '../pqm/Fields/PqmFieldOrgDivision';
import * as pqm_Fields_PqmFieldAttach from '../pqm/Fields/PqmFieldAttach';
import * as ticketOverview_TOIPqm from '../ticketOverview/TOIPqm';
import * as components_TicketAccountSelector from '../components/TicketAccountSelector';
import * as ticketTypeFormField from '../TicketTypeFormField';
import * as ticketRelField from '../TicketRelField';
import * as uiTicketFieldAttaches from '../UiTicketFieldAttaches';
import * as invoiceCreator from '../InvoiceCreator';
import * as uiTicketRels from '../UiTicketRels';
import * as uiSplitByAttach from '../UiSplitByAttach';
import * as uiAttaches from '../UiAttaches';
import * as uiProductImport from '../UiProductImport';
import * as attaches2 from '../Attaches2';
import * as ticketOverview_pqm_UiPqmFilter from '../ticketOverview/pqm/UiPqmFilter';
import * as worklogEditor from '../WorklogEditor';

export function registerWidgets() {
    MuWidget.registerAll(
        uiScripting,
        htmlarea,
        uiFlashMessage,
        uiSelector,
        ticketTree,
        invoiceApproval,
        uiFlashMessage,
        accountSelector,
        searchSelector,
        approvingSchemaEditor,
        ticketTree,
        accountRoles,
        shareButton,
        tPFAttaches,
        treeSelector,
        multiUpload,
        ticketFormField,
        worklogSimple,
        showMore,
        accountRolesField,
        bulkStateChange,
        accountRolesField,
        uiBilling,
        uiSavedFilters,
        uiSavedFiltersAdmin,
        uiNotify,
        urlInput,
        showMore,
        course,
        courseEditor,
        searchSelector,
        uiSelect,
        cronRuleItems,
        calendarPage,
        uiCalendarItemDetail,
        topPage,
        todoTicketForm,
        attachList,
        components_UiTable,
        components_UiTomSelect,
        components_UiBuSubjectSelector,
        components_UiOrgProjectSelector,
        components_UiAccountSelector,
        components_UiDateFilter,
        components_UiRadioList,
        components_UiPager,
        components_UiTree,
        components_UiInlineTreeSelector,
        components_UiDateTimeRange,
        components_UiNumberRange,
        components_Pager,
        components_AccountLink,
        components_TreeView,
        components_UiChboxList,
        components_BaseCompanyForm,
        components_RelatedAccountSelector,
        uiCharCounter,
        components_DateRepeating,
        components_CalendarOverview,
        dms_UiDms,
        dms_UiBuSubjectEditor,
        dms_UiDmsDocumentEditor,
        dms_UiBuSubjects,
        dms_UiDmsDocuments,
        dms_UiDocumentListPreview,
        dms_UiDmsAttaches,
        dms_UiDmsHistory,
        dms_UiDmsOrgProjects,
        dms_UiNewDocumentAttach,
        pqm_ProcDataField,
        uiProjectImport,
        todo_UiTodoButton,
        uiComments,
        uiModalContainer,
        ticketOverview_BaseTO,
        ticketOverview_TOInvoiceApproving,
        ticketOverview_TOIInvoiceApproving,
        ticketOverview_InvoiceApprovingFilter,
        ticketOverview_TOPqm,
        ticketOverview_pqm_UiPqmLauncher,
        pqm_PqmTicketList,
        pqm_PqmTicketDetail,
        pqm_PqmField,
        pqm_PqmPackets,
        pqm_Fields_PqmFieldText,
        pqm_Fields_PqmFieldDate,
        pqm_Fields_PqmFieldBool,
        pqm_Fields_PqmFieldEnum,
        pqm_Fields_PqmFieldSet,
        pqm_Fields_PqmFieldCompany,
        pqm_Fields_PqmFieldAccount,
        pqm_Fields_PqmFieldOrgDivision,
        pqm_Fields_PqmFieldAttach,
        ticketOverview_TOIPqm,
        components_TicketAccountSelector,
        ticketTypeFormField,
        ticketRelField,
        uiTicketFieldAttaches,
        invoiceCreator,
        uiTicketRels,
        uiSplitByAttach,
        uiAttaches,
        uiProductImport,
        attaches2,
        ticketOverview_pqm_UiPqmFilter,
        worklogEditor,
    );
}
